'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RightArrowCircledOutline = require('./RightArrowCircledOutline');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RightArrowCircledOutline).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/RightArrowCircledOutline/index.js
// module id = 1280
// module chunks = 1